import { Component, ComponentRef, Injector, Input, NgZone, ViewContainerRef, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { BaseComponentWithDialog } from "../../../admin-panel/base-admin-panel/base-component-with-dialog";
import { GeozoneViewModel } from "../../../admin-panel/Geozone/Model/GeozoneViewModel";
import { CreateGeozoneDialogComponent } from "../../../admin-panel/Geozone/create-geozone-dialog/create-geozone-dialog.component";
import { JSProxyService } from "../../../../services/jsproxy.service";
import { ContainersService } from "app/services/containers.service";
import { ContainerAcl } from "app/models/ContainerAcl";
import { Subject, takeUntil } from 'rxjs';

import { ObjectGroupViewModel } from "../../../admin-panel/ObjectGroupViewModel";
import { GroupManagementDialogComponent } from "../../../admin-panel/group-management-dialog/group-management-dialog.component";

@Component({
    selector: 'app-geozones-list',
    templateUrl: './geozones-list.component.html',
    styleUrls: ['./geozones-list.component.css'],
    standalone: false
})

export class GeozonesListComponent extends BaseComponentWithDialog implements OnInit,OnDestroy
{
  groupMgmtDialog: ComponentRef<any>;
  @ViewChild("groupMgmtDialog", { read: ViewContainerRef, static: true }) groupsContainer;

  jsProxy: JSProxyService;
  ngZone: NgZone;
  private containersService: ContainersService;
  public canCreateGeozone: boolean = false;
  private readonly destroy$ = new Subject<void>();

  constructor(protected injector: Injector)
  {
    super(injector);
    this.jsProxy = injector.get(JSProxyService);
    this.ngZone = injector.get(NgZone);
    this.containersService = injector.get(ContainersService);
  }

  ngOnInit()
  {
    this.jsProxy.registerComponent("GeozoneEditor", this, "");
    this.loadCreatePermissions();
    this.usersService.onInit.pipe(takeUntil(this.destroy$)).subscribe(() => this.loadCreatePermissions());
  }

  ngOnDestroy()
  {
    this.jsProxy.unRegisterComponent("GeozoneEditor");
    this.destroy$.next();
    this.destroy$.complete();
  }

  public show(type: string, points: string) {
    this.ngZone.run(() => {
      if (!this.canCreateGeozone) return;

      const model = new GeozoneViewModel();
      model.Style.type = type;
      model.Style.strokeColor = "#2233FF";
      model.Style.strokeWidth = 2;
      model.Style.strokeOpacity = (type == "polyline") ? 1 : 0.2;
      model.Style.fillColor = "#2233FF";
      model.Style.fillOpacity = 0.2;
      model.Points = points;
      this.prepareModal(CreateGeozoneDialogComponent);
      this.componentRef.instance.open(model);
    });
  }

  //public edit(driver: DriverWithGroupsViewModel) {
    //this.prepareModal(EditDriverComponent);
    //this.componentRef.instance.open(driver);
 // }

  public сreate()
  {
    //this.prepareModal(CreateDriverComponent);
    //this.componentRef.instance.open(new DriverWithGroupsViewModel());
  }

  public createGroup()
  {
    this.ngZone.run(() => {
      this.groupMgmtDialog = this.dialogService.open(this.groupsContainer, GroupManagementDialogComponent);

      this.groupMgmtDialog.instance.onSubmit.subscribe(() => {
        this.groupMgmtDialog.instance.close();
      });

      this.groupMgmtDialog.instance.open(new ObjectGroupViewModel());
    });
  }

  private loadCreatePermissions() {
    const currentUser = this.usersService.getCurrentUser();
    if (!currentUser) {
      this.canCreateGeozone = false;
      return;
    }

    if (currentUser.CanDo(this.AccessRights.EDITUSERS) || currentUser.CanDo(this.AccessRights.EDIT_ALL_USERS)) {
      this.canCreateGeozone = true;
      return;
    }

    this.containersService.GetContainers().subscribe(containers => {
      const userId = currentUser.Id;
      this.canCreateGeozone = (containers ?? []).some(container => {
        const acl = container.Users?.find(link => link.UserId === userId)?.ACL
          ?? currentUser.ContainerLinks?.find(link => link.ContainerId === container.Id)?.ACL
          ?? 0;

        return (acl & ContainerAcl.CreateGeozone) === ContainerAcl.CreateGeozone;
      });
    });
  }
}
